import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';
import { CustomToast } from '../../../util/CustomToast';

import { Storage } from '@ionic/storage';

import { ImageSelector } from '../../../util/imageSelector/imageSelector';

import { AddSlidePage } from './addSlide/addSlide';
import { SlidePage } from './slide/slide';

@Component({
  selector: 'page-slides',
  templateUrl: 'slides.html',
  providers : [HttpClient, CustomToast]
})
export class SlidesPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  slides;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  customToast : CustomToast;
  events : Events;
  storage : Storage;
  alertCtrl : AlertController;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events,storage : Storage, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();

    this.customToast = customToast;
    this.events = events;
    this.storage = storage;
    this.alertCtrl = alertCtrl;
    this.events.subscribe('addSlide:done',()=>{
      this.httpCallSlides();
    });
    this.events.subscribe('slide:update',()=>{
        this.httpCallSlides();
      });
      this.events.subscribe('slide:delete',()=>{
        this.httpCallSlides();
      });
    this.httpCallSlides();
	}

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector, {isProfile : true});
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
      }
    });
  }

  httpCallSlides(){
    this.httpClient.get('/slides',(error,data)=>{
      this.slides = data.json();
    });
  }

  onClickAdd(){
    this.navCtrl.push(AddSlidePage);
  }

  onClickSlide(slide){
    this.navCtrl.push(SlidePage,{id : slide.id});
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/slides/slides.ts